import { useState } from 'react';
import LogsPreview from '../LogsPreview';
import CalendarView from '../../CalendarView';
import PracticeManagementWidget from '../PracticeManagementWidget';
import OnboardDoctor from '../OnboardDoctor';
import { useClinicData } from '../../utils/useClinicData';
import { useAuth } from '../../utils/AuthContext';

export default function SuperAdminDashboard() {
    const { user, token } = useAuth();
    const isSuperAdmin = user.role === 'super_admin';
    const { clinics, selectedClinic, setSelectedClinic, selectedLocation, setSelectedLocation, filteredLocations, doctors, refreshDoctors } = useClinicData();

    const singleDoctor = doctors.length === 1? doctors[0] : null;

    const [onboardDoctor, setOnboardDoctor] = useState(false);

    return (
        <div>
            <section className="p-6">
                <div className='flex justify-end'>
                    <img src="/assets/invoco_icon_transparent_purple.webp" alt="invoco Logo Icon" className="h-12 w-12"/>
                </div>

                
                <div className='grid grid-cols-1 gap-3'>
                    {/* LOGS  */}
                    <div className='rounded-2xl bg-white/80 backdrop-blur border border-slate-200 p-6 shadow-sm'>
                        <h2 className='text-xl font-semibold text-slate-800 mb-4'>logs</h2>
                        <div className='max-h-64 overflow-y-auto'>
                            <LogsPreview locationId={selectedLocation?.locationId}/>
                        </div>
                        
                    </div>
                    {/* PRACTICE MANAGEMENT  */}
                    <div className='rounded-2xl bg-white/80 backdrop-blur border border-slate-200 p-6 shadow-sm'>
                        <h2 className='text-xl font-semibold text-slate-800 mb-4'>practice management</h2>

                        {isSuperAdmin && (
                            <div className='mb-4 max-w-sm'>
                                <label className='block text-xs font-semibold uppercase tracking-wide text-slate-600 mb-1'>viewing clinic</label>
                                <select value={selectedClinic || ''} onChange={(event) => setSelectedClinic(event.target.value)} className='w-full rounded-md border border-slate-300 bg-slate-50 px-3 py-1.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-docpgrPurple'>
                                    <option value='' disabled>
                                        select a clinic
                                    </option>
                                    {clinics.map((clinic) => (
                                        <option key={clinic.clinic_id} value={clinic.clinic_id}>
                                            {clinic.clinic_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <PracticeManagementWidget clinicId={ isSuperAdmin ? selectedClinic : user.clinic_id } role={user.role}/>
                    </div>
                    {/* CALENDAR  */}
                    <div className='rounded-2xl bg-white/80 backdrop-blur border border-slate-200 p-6 shadow-sm'>
                        <h2 className='text-xl font-semibold text-slate-800 mb-4'>calendar view</h2>
                        <div className='p-3 sm:flex-col'>
                            <select value={selectedClinic} onChange={(event) => setSelectedClinic(event.target.value)} className='p-2 border rounded-md mb-2 mx-4' >
                                <option value='' disabled>-Select Clinic-</option>
                                {clinics.map((clinic) => (
                                    <option key={clinic.clinic_id} value={clinic.clinic_id}>
                                        {clinic.clinic_name}
                                    </option>
                                ))}
                            </select>
                            {selectedClinic && (
                                <select value={selectedLocation?.location_id || ''} onChange={(event) => setSelectedLocation(filteredLocations.find(location => location.location_id === parseInt(event.target.value)))} className='rounded-md border p-2 mx-4'>
                                    <option value='' disabled>-Select a Location-</option>
                                    {filteredLocations.map((location) => (
                                        <option key={location.location_id} value={location.location_id}>
                                            {location.location_name}
                                        </option>
                                    ))}
                                </select>
                            )}

                            {selectedLocation && (
                                <div>
                                    {doctors.length === 0 ? (
                                        <p className='text-gray-700 font-semibold p-4'>
                                            No doctors registered yet for {selectedLocation.location_name}. 
                                            <button onClick={() => setOnboardDoctor(true)} className='text-docpgrPurple border py-1 px-3  mx-4 rounded-lg hover:text-white hover:bg-docpgrPurple90 font-semibold bg-docpgrPurple10'>
                                                Register Doctor
                                            </button>
                                        </p>        
                                     ) : singleDoctor ? (
                                        <p className='text-gray-700 font-semibold p-4'>
                                            Only one doctor registered to {selectedLocation.location_name}. <span className='font-bold'>{singleDoctor.doctor_name}</span> will receive all notifications.
                                        </p>
                                    ) : (
                                        <CalendarView clinicId={selectedClinic} clinicName={clinics.find(clinic => clinic.clinic_id === parseInt(selectedClinic))?.clinic_name} location={selectedLocation} />
                                    )}
                                    
                                </div>
                            )}
                        </div>
                    </div>

                    {onboardDoctor && (
                        <OnboardDoctor isOpen={onboardDoctor} onClose={() => setOnboardDoctor(false)} clinicId={selectedClinic } locationId={selectedLocation.location_id} token={token} onSuccess={refreshDoctors} userRole={user.role}/>
                    )}

                </div>
            </section>
        </div>
    )
}